define([
	"dojo/_base/declare",
	"csi/action",
	"csi/heading/BooleanController",
	"csi/xml"
], function(declare,action,BooleanController,xml) {

	return declare(BooleanController, {
		_bSyncColorways: false,

		confirmAction: function(/*Object*/params) {
			// summary: customize confirmation dialog
			params.buttons = ["Y","N","C"];
			params.message = this.getString(action.SUFFIX_CONFIRM + "_" + this._getCheckboxValue());
			this.inherited(arguments);
		},

		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == "C") {
				this.checkbox.set("value", this.oldValue);
				this.postProcess();
			} else {
				this._bSyncColorways = (key == "Y");
				this.preProcess();
			}
		},

		toWriterRequest: function() {
			// summary: add sync parameter to request
			return this.inherited(arguments).addParameter("Sync", xml.ATTR_BOOLEAN, this._bSyncColorways);
		}
	});
});